module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sidebarCurrentPanel === 'style'),
      expression: "sidebarCurrentPanel === 'style'"
    }],
    staticClass: "kp-modular-submenu kp-modular-submenu-tab kp-animate-tab-open"
  }, [_c('div', {
    staticClass: "kp-modular-tab pt-page no-fade pt-page-current"
  }, [_c('header', {
    staticClass: "kp-modular-title"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('general.labels.edition')) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "submenu-content sub-color"
  }, [_c('modifiers-config'), _vm._v(" "), _c('trigger-button-config'), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.boxConfig.advanced.view_mode === 'automatic'),
      expression: "boxConfig.advanced.view_mode === 'automatic'"
    }],
    staticClass: "btn",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.sidebarChangePanel('exibitionmode');
        _vm.sidebarChangeActiveButton('advancedconfig');
        _vm.canvasChangeView('preview');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.configure_box')))])], 1)])])])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-133851b5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/config/Main.vue
 ** module id = 767
 ** module chunks = 1
 **/